import { useContext } from 'react';
import { VideoStagingContext } from '../context/VideoStagingContext';
import { VideoStagingContextValue } from '../common/model/type/video-staging.types';

export function useVideoStagingSession(): VideoStagingContextValue {
  const context = useContext(VideoStagingContext);

  if (!context) {
    throw new Error(
      'useVideoStagingSession must be used inside OvVideoStagingProvider'
    );
  }

  return context;
}
